module.exports = __webpack_public_path__ + "img/health1.2cffeee8.png";